export default __webpack_public_path__ + "static/media/16.be0a3c18.jpg";